<template>
  <div class="pd-page">
    <div class="table-wrap">
      <div class="table-head">
        <div>
          <h2>Tüm Tahsilatlar</h2>

          <div
            v-if="providerFilter || statusFilter || sourceFilter || keyword || startDate || endDate"
            class="active-filters"
          >
            <span v-if="providerFilter" class="filter-pill">
              Sağlayıcı: {{ providerName(providerFilter) }}
            </span>
            <span v-if="statusFilter" class="filter-pill">
              Durum: {{ statusText(statusFilter) }}
            </span>
            <span v-if="sourceFilter" class="filter-pill">
              Kaynak: {{ sourceText(sourceFilter) }}
            </span>
            <span v-if="keyword" class="filter-pill">
              Arama: {{ keyword }}
            </span>
            <span v-if="startDate" class="filter-pill">
              Başlangıç: {{ startDate }}
            </span>
            <span v-if="endDate" class="filter-pill">
              Bitiş: {{ endDate }}
            </span>
          </div>
        </div>

        <div class="table-filters">
          <input
            v-model.trim="keyword"
            class="pd-input"
            placeholder="Sipariş no / başlık ara"
          />

          <input v-model="startDate" type="date" class="pd-input" />
          <input v-model="endDate" type="date" class="pd-input" />

          <select v-model="statusFilter" class="pd-input">
            <option value="">Tüm Durumlar</option>
            <option value="paid">Başarılı</option>
            <option value="failed">Başarısız</option>
            <option value="3d_pending">Bekleyen</option>
          </select>

          <select v-model="sourceFilter" class="pd-input">
            <option value="">Tüm Kaynaklar</option>
            <option value="manuel">Manuel</option>
            <option value="odeme_linki">Ã–deme Linki</option>
            <option value="siparis">Sipariş</option>
          </select>

          <select v-model="providerFilter" class="pd-input">
            <option value="">Tüm Sağlayıcılar</option>
            <option
              v-for="p in providerOptions"
              :key="'provider-' + p.provider_code"
              :value="p.provider_code"
            >
              {{ p.provider_name }}
            </option>
          </select>
        </div>

        <div class="pd-actions">
          <button class="pd-btn" @click="clearFilters">Filtreleri Temizle</button>
          <button class="pd-btn primary" @click="fetchAll" :disabled="loading">
            {{ loading ? "Yükleniyor..." : "Yenile" }}
          </button>
        </div>
      </div>

      <div v-if="loading" class="empty-box">
        Veriler yükleniyor...
      </div>

      <div v-else-if="filteredRows.length === 0" class="empty-box">
        Kayıt bulunamadı.
      </div>

      <!-- DESKTOP -->
	      <div v-else class="pd-table desktop-only">
	        <div class="pd-tr pd-th">
          <div>Sipariş No</div>
          <div>Başlık</div>
          <div>Sağlayıcı</div>
          <div>Kaynak</div>
          <div>Tutar</div>
          <div>Fark</div>
          <div>Toplam</div>
          <div>Taksit</div>
          <div>Durum</div>
	          <div>Tarih</div>
	          <div class="th-center">Entegrasyon</div>
	        </div>

	        <div
	          v-for="row in filteredRows"
	          :key="row.id || row.order_no"
	          class="pd-tr pd-tr-click"
	          @click="openDetail(row)"
	        >
          <div class="mono">{{ row.order_no || "-" }}</div>

          <div class="title-cell">
            <div class="title-main">{{ row.customer_name || "-" }}</div>
            <div class="title-sub">
              <span v-if="row.customer_phone">{{ row.customer_phone }}</span>
              <span v-if="row.customer_phone && row.customer_email" class="sep">Â·</span>
              <span v-if="row.customer_email">{{ row.customer_email }}</span>
              <span v-if="!row.customer_phone && !row.customer_email">-</span>
            </div>
          </div>

          <div class="provider-cell">
            <span class="provider-badge">
              {{ row.provider_name || row.provider_code || "-" }}
            </span>
          </div>

          <div>
            <span class="source-pill">{{ sourceText(row.payment_source) }}</span>
          </div>

          <div>{{ fmtMoney(row.amount) }}</div>
          <div>{{ fmtMoney(row.fee_amount) }}</div>
          <div>{{ fmtMoney(row.total_amount) }}</div>
          <div>{{ row.installment || 1 }}</div>

          <div>
            <span class="status-pill" :class="'st-' + safeStatus(row.status)">
              {{ statusText(row.status) }}
            </span>
          </div>

	          <div>{{ formatDate(row.created_at) }}</div>
	          <div class="td-center">
	            <button v-if="row.status === 'paid' && hesap.root==1" type="button" class="pd-btn xs purple" @click.stop="openIntegrate(row)">Entegre</button>
	          </div>
	        </div>
	      </div>

      <!-- MOBILE -->
      <div v-if="filteredRows.length" class="mobile-only mobile-list">
        <div
          v-for="row in filteredRows"
          :key="'m-' + (row.id || row.order_no)"
          class="mobile-row"
          @click="openDetail(row)"
        >
          <div class="mobile-top">
            <div class="mobile-left">
              <div class="mobile-title">{{ row.customer_name || "-" }}</div>
              <div class="mobile-contact">
                <span v-if="row.customer_phone">{{ row.customer_phone }}</span>
                <span v-if="row.customer_phone && row.customer_email" class="sep">Â·</span>
                <span v-if="row.customer_email">{{ row.customer_email }}</span>
                <span v-if="!row.customer_phone && !row.customer_email">-</span>
              </div>
            </div>

            <div class="mobile-amount">{{ fmtMoney(row.total_amount) }}</div>
          </div>

          <div class="mobile-bot">
            <span class="provider-badge small">{{ row.provider_name || row.provider_code || "-" }}</span>
            <span class="status-pill small" :class="'st-' + safeStatus(row.status)">{{ statusText(row.status) }}</span>
            <span class="mono">{{ row.order_no || "-" }}</span>
            <button v-if="row.status === 'paid'" type="button" class="pd-btn xs purple" @click.stop="openIntegrate(row)">Entegre</button>
          </div>
        </div>
	      </div>
	    </div>

	    <!-- Entegrasyon Modal -->
	    <div v-if="integrateOpen" class="pd-overlay im-overlay" @click="closeIntegrate"></div>
	    <div v-if="integrateOpen" class="imodal" @click.stop>
	      <div class="im-head">
	        <div>
	          <div class="im-title">Mikro Entegrasyon</div>
	          <div class="im-sub mono">{{ integrateCariKod || "-" }}</div>
	        </div>
	        <button class="sb-close" type="button" @click="closeIntegrate">Ã—</button>
	      </div>

	      <div v-if="integrateLoading" class="sb-loading">Lütfen bekleyiniz...</div>
	      <div v-else-if="integrateError" class="sb-error">{{ integrateError }}</div>

	      <div v-else class="im-body">
	        <div class="im-controls">
	          <div class="im-ctrl">
	            <div class="im-label">SM</div>
	            <select v-model="integrateSm" class="pd-input" @change="onIntegrateSmChange">
	              <option value="">Seçiniz</option>
	              <option v-for="(x, i) in mikroSmler" :key="'sm-' + i" :value="smValue(x)">
	                {{ smLabel(x) }}
	              </option>
	            </select>
	          </div>
	          <div class="im-ctrl">
	            <div class="im-label">Banka</div>
	            <select v-model="integrateBanka" class="pd-input" @change="onIntegrateBankaChange">
	              <option value="">Seçiniz</option>
	              <option v-for="(x, i) in mikroBankalar" :key="'bnk-' + i" :value="bankaValue(x)">
	                {{ bankaLabel(x) }}
	              </option>
	            </select>
	          </div>
	        </div>

	        <div class="im-table">
	          <div class="im-tr im-th">
	            <div>Taksit</div>
	            <div>Cari</div>
	            <div>SM</div>
	            <div>Banka</div>
	            <div>Vade</div>
	            <div class="im-right">Meblağ</div>
	          </div>
	          <div v-for="(r, idx) in integrateRows" :key="'ir-' + idx" class="im-tr">
	            <div class="mono">{{ idx + 1 }}</div>
	            <div class="mono">{{ r.cha_kod || "-" }}</div>
	            <div class="mono">{{ r.cha_srmrkkodu || "-" }}</div>
	            <div class="mono">{{ r.cha_kasa_hizkod || "-" }}</div>
	            <div class="mono">{{ r.cha_vade }}</div>
	            <div class="mono im-right">{{ r.cha_meblag }}</div>
	          </div>
	        </div>
	      </div>
	    </div>

	    <!-- Sidebar -->
	    <div v-if="sidebarOpen" class="pd-overlay" @click="closeSidebar"></div>
	    <aside v-if="sidebarOpen" class="pd-sidebar" @click.stop>
	      <div class="sb-head">
	        <div class="sb-title">Tahsilat Detayı</div>
	        <button class="sb-close" type="button" @click="closeSidebar">Ã—</button>
	      </div>

	      <div v-if="detailLoading" class="sb-loading">Lütfen bekleyiniz...</div>
	      <div v-else-if="detailError" class="sb-error">{{ detailError }}</div>

		      <div v-else class="sb-body">
		        <div class="sb-summary">
		          <div class="sum-left">
		            <div class="sum-order mono">{{ (selectedRow && selectedRow.order_no) || "-" }}</div>
		            <div class="sum-sub">{{ (selectedRow && (selectedRow.customer_name || selectedRow.baslik)) || "-" }}</div>
		          </div>
		          <div class="sum-right">
		            <span class="status-pill big" :class="'st-' + safeStatus((detail && detail.status) || (selectedRow && selectedRow.status))">
		              {{ statusText((detail && detail.status) || (selectedRow && selectedRow.status)) }}
		            </span>
		          </div>
		        </div>

		        <div class="sb-sec sec-payment">
  <div class="sb-sec-title">Ödeme Bilgileri</div>
  <div class="acc-box">
    <div class="row"><span>İşlem Tipi</span><b>{{
      isbankParsed
        ? (isbankParsed.chargeType === 'S' ? 'Satış' : (isbankParsed.chargeType || '-'))
        : ((detail && detail.raw && detail.raw.paymentSet && detail.raw.paymentSet.transactionType) || "-")
    }}</b></div>
    <div class="row"><span>İşlem Durumu</span><b>{{ statusText(detail && detail.status) }}</b></div>
    <div class="row"><span>İşlem Tarihi</span><b>{{
      isbankParsed
        ? formatDate(isbankParsed.captureDttm || isbankParsed.authDttm || isbankParsed.hostDate)
        : formatDate(detail && detail.raw && detail.raw.transactionDate)
    }}</b></div>
    <div class="row"><span>Sağlayıcı Referans</span><b class="mono">{{
      (isbankParsed && (isbankParsed.authCode || isbankParsed.hostRefNum)) || (detail && detail.providerReference) || "-"
    }}</b></div>
    <div class="row"><span>İşlem Numarası</span><b class="mono">{{
      (isbankParsed && isbankParsed.transId) || (detail && detail.providerTransactionId) || "-"
    }}</b></div>
    <div class="row"><span>Hata Kodu</span><b class="mono">{{
      (orderDetail && (orderDetail.fail_code || orderDetail.failCode))
      || (selectedRow && (selectedRow.fail_code || selectedRow.failCode))
      || (detail && detail.errorCode)
      || (isbankParsed && isbankParsed.procReturnCode)
      || "-"
    }}</b></div>
    <div class="row"><span>Hata Mesajı</span><b>{{
      (orderDetail && (orderDetail.fail_message || orderDetail.failMessage))
      || (selectedRow && (selectedRow.fail_message || selectedRow.failMessage))
      || (detail && (detail.errorMessage || (detail.raw && detail.raw.errorMessage)))
      || (isbankParsed && isbankParsed.errMsg)
      || "-"
    }}</b></div>
  </div>
</div>

		        <div class="sb-sec sec-card">
		          <div class="sb-sec-title">Kart Bilgileri</div>
		          <div class="acc-box">
		            <div class="row"><span>Kart Üzerindeki İsim</span><b>{{ (cardInfo && cardInfo.cardHolderName) || "-" }}</b></div>
		            <div class="row"><span>Kart Tipi</span><b>{{ (cardInfo && cardInfo.cardType) || "-" }}</b></div>
		            <div class="row"><span>Kart Numarası</span><b class="mono">{{ (cardInfo && cardInfo.cardNumber) || "-" }}</b></div>
		            <div class="row"><span>Kart Bankası</span><b>{{ (cardInfo && cardInfo.cardBank) || "-" }}</b></div>
		            <div class="row"><span>Kart Sınıfı</span><b>{{ (cardInfo && cardInfo.cardClass) || "-" }}</b></div>
		          </div>
		        </div>

		        <div class="sb-sec sec-contact">
		          <div class="sb-sec-title">İletişim Bilgileri</div>
		          <div class="acc-box">
		            <div class="row"><span>TCKN / VKN</span><b class="mono">{{ (orderDetail && (orderDetail.customer_vkn || orderDetail.customer_vno)) || (selectedRow && selectedRow.customer_vkn) || (contactInfo && contactInfo.taxNumber) || "-" }}</b></div>
		            <div class="row"><span>Ad Soyad / Ünvan</span><b>{{ (orderDetail && orderDetail.customer_name) || (selectedRow && selectedRow.customer_name) || (contactInfo && contactInfo.fullName) || "-" }}</b></div>
		            <div class="row"><span>Telefon</span><b class="mono">{{ (orderDetail && orderDetail.customer_phone) || (selectedRow && selectedRow.customer_phone) || (contactInfo && contactInfo.phoneNumber) || "-" }}</b></div>
		            <div class="row"><span>E-Posta</span><b>{{ (orderDetail && orderDetail.customer_email) || (selectedRow && selectedRow.customer_email) || (contactInfo && contactInfo.email) || "-" }}</b></div>
		            <div class="row"><span>Açıklama</span><b>{{ (orderDetail && orderDetail.customer_message) || (contactInfo && contactInfo.description) || "-" }}</b></div>
		          </div>
		        </div>
		      </div>
	    </aside>
	  </div>
	</template>

<script>
import db from "../../db";
export default {
  name: "TahsilatList",

	  data() {
	    return {
              hesap:this.$request.ayar(),

	      loading: false,
	      keyword: "",
	      statusFilter: "",
	      providerFilter: "",
	      sourceFilter: "",
	      startDate: "",
	      endDate: "",
	      rows: [],
	      allowedCariGuidSet: null,
	      allowedCariMatchers: null,
	      allowedCariReady: false,
	      _cariFilterLogged: false,
	      mikroSmler: [],
	      mikroBankalar: [],
	      integrateOpen: false,
	      integrateLoading: false,
	      integrateError: "",
	      integrateRows: [],
	      integrateSm: "",
	      integrateBanka: "",
	      integrateCariKod: "",
	      selectedRow: null,
		      sidebarOpen: false,
		      detailLoading: false,
		      providerDetail: null,
		      orderDetail: null,
		      detailError: "",
		      accOpen: null
		    };
		  },

  computed: {
    providerOptions() {
      const map = {};
      (Array.isArray(this.rows) ? this.rows : []).forEach((row) => {
        const code = String(row.provider_code || "").trim();
        if (!code) return;
        if (!map[code]) {
          map[code] = {
            provider_code: code,
            provider_name: row.provider_name || code
          };
        }
      });
      return Object.values(map).sort((a, b) =>
        String(a.provider_name).localeCompare(String(b.provider_name))
      );
    },

	    filteredRows() {
      const kw = String(this.keyword || "").toLowerCase();
      const allowSet = this.allowedCariGuidSet;
      const allowReady = this.allowedCariReady;

      if (!allowReady) return [];

      return (Array.isArray(this.rows) ? this.rows : []).filter((row) => {
        if (allowReady) {
          const rawCarid =
            row && (typeof row.carid !== "undefined" || typeof row.customer_carid !== "undefined" || typeof row.currentAccountId !== "undefined" || typeof row.current_account_id !== "undefined")
              ? (row.carid || row.customer_carid || row.currentAccountId || row.current_account_id || "")
              : "";
          const carid = this.normalizeGuid(rawCarid);
          if (carid) {
            if (!allowSet || !allowSet.has(carid)) return false;
          } else {
            // Fallback: backend list may not include carid; match by email/phone/name against local caris
            const m = this.allowedCariMatchers;
            const email = String((row && row.customer_email) || "").trim().toLowerCase();
            const phone = String((row && row.customer_phone) || "").replace(/\D/g, "");
            const name = String((row && row.customer_name) || "").trim().toLowerCase();
            const ok =
              !!(m && (
                (email && m.emails && m.emails.has(email)) ||
                (phone && m.phones && m.phones.has(phone)) ||
                (name && m.names && m.names.has(name))
              ));
            if (!ok) return false;
          }
        }

        const statusOk = !this.statusFilter || row.status === this.statusFilter;
        const providerOk = !this.providerFilter || row.provider_code === this.providerFilter;
        const sourceOk = !this.sourceFilter || row.payment_source === this.sourceFilter;

        const text = [
          row.order_no,
          row.baslik,
          row.customer_name,
          row.customer_phone,
          row.customer_email,
          row.provider_name,
          row.provider_code
        ]
          .join(" ")
          .toLowerCase();

        const keywordOk = !kw || text.indexOf(kw) > -1;

        let dateOk = true;
        if (this.startDate || this.endDate) {
          const rowDate = this.normalizeDateOnly(row.created_at);
          if (!rowDate) {
            dateOk = false;
          } else {
            if (this.startDate && rowDate < this.startDate) dateOk = false;
            if (this.endDate && rowDate > this.endDate) dateOk = false;
          }
        }

        return statusOk && providerOk && sourceOk && keywordOk && dateOk;
      });
	    }
	    ,
	    detail() {
	      let d = this.providerDetail || null;
	      if (d && d.data) d = d.data;
	      if (d && d.transactionResult) d = d.transactionResult;
	      return d;
	    },
	    cardInfo() {
	      const d = this.detail;
	      if (!d) return null;
	      const p = this.isbankParsed;
	      if (p) {
	        return {
	          cardHolderName: null,
	          cardType: null,
	          cardNumber: p.pan || null,
	          cardBank: null,
	          cardClass: null
	        };
	      }
	      return d && d.raw ? (d.raw.creditCard || null) : null;
	    },
	    contactInfo() {
	      const d = this.detail;
	      if (!d) return null;
	      const p = this.isbankParsed;
	      if (p) {
	        return {
	          taxNumber: null,
	          fullName: (this.selectedRow && (this.selectedRow.customer_name || this.selectedRow.baslik)) || null,
	          description: null,
	          phoneNumber: (this.selectedRow && this.selectedRow.customer_phone) || null,
	          email: (this.selectedRow && this.selectedRow.customer_email) || null
	        };
	      }
	      return d && d.raw ? (d.raw.paymentContact || null) : null;
	    }
	    ,
	    isbankParsed() {
	      const d = this.detail;
	      const xml = d && d.raw ? (d.raw.responseXml || d.raw.response_xml || "") : "";
	      if (!xml || typeof xml !== "string") return null;
	      // very fast check: CC5 response
	      if (xml.indexOf("<CC5Response") === -1 && xml.indexOf("<CC5RESPONSE") === -1) return null;
	      try {
	        const doc = new DOMParser().parseFromString(xml, "text/xml");
	        const get = (tag) => {
	          const el = doc.getElementsByTagName(tag)[0];
	          return el && el.textContent != null ? String(el.textContent).trim() : "";
	        };
	        const extraGet = (tag) => {
	          // sometimes tags are directly under Extra; DOMParser already handles
	          return get(tag);
	        };
	        return {
	          response: get("Response"),
	          procReturnCode: get("ProcReturnCode"),
	          errMsg: get("ErrMsg"),
	          orderId: get("OrderId") || get("ORD_ID"),
	          transId: get("TransId") || get("TRANS_ID"),
	          authCode: extraGet("AUTH_CODE"),
	          authDttm: extraGet("AUTH_DTTM"),
	          captureDttm: extraGet("CAPTURE_DTTM"),
	          hostDate: extraGet("HOSTDATE"),
	          captureAmt: extraGet("CAPTURE_AMT"),
	          origAmt: extraGet("ORIG_TRANS_AMT"),
	          chargeType: extraGet("CHARGE_TYPE_CD"),
	          transStat: extraGet("TRANS_STAT"),
	          pan: extraGet("PAN"),
	          hostRefNum: extraGet("HOST_REF_NUM"),
	          procRetCd: extraGet("PROC_RET_CD"),
	          mdStatus: extraGet("MDSTATUS"),
	          settleId: extraGet("SETTLEID")
	        };
	      } catch (e) {
	        return null;
	      }
	    }
	  },

	  created() {
    this.$store.setLoading([false, ""]);
    this.fetchMikroMeta();
    this.loadAllowedCaris();
    this.fetchAll();
  },

	  methods: {
	    normalizeGuid(v) {
	      const s = String(v || "").trim();
	      if (!s) return "";
	      return s.replace(/[{}()\s-]/g, "").toUpperCase();
	    },

	    async loadAllowedCaris() {
	      try {
	        this.allowedCariReady = false;
	        const items = await db.caris.toArray();
	        const set = new Set();
	        const match = {
	          emails: new Set(),
	          phones: new Set(),
	          names: new Set()
	        };
	        (Array.isArray(items) ? items : []).forEach((c) => {
	          const v = this.normalizeGuid(c && c.guid);
	          if (v) set.add(v);

	          const email = String((c && (c.mail || c.email)) || "").trim().toLowerCase();
	          if (email) match.emails.add(email);

	          const phone = String((c && (c.gsm || c.telefon || c.phone)) || "").replace(/\D/g, "");
	          if (phone) match.phones.add(phone);

	          const name = String((c && (c.unvan || c.ad || c.adi || c.name)) || "").trim().toLowerCase();
	          if (name) match.names.add(name);
	        });
	        console.log("[tahsilat/list] allowedCariGuidSet size =", set.size);
	        if (items && items.length) {
	          console.log("[tahsilat/list] allowedCari sample guid =", items.slice(0, 5).map((x) => x && x.guid));
	        }
	        this.allowedCariGuidSet = set;
	        this.allowedCariMatchers = match;
	      } catch (e) {
	        this.allowedCariGuidSet = new Set();
	        this.allowedCariMatchers = { emails: new Set(), phones: new Set(), names: new Set() };
	      } finally {
	        this.allowedCariReady = true;
	        this.logCariFilterStats();
	      }
	    },

	    logCariFilterStats() {
	      if (this._cariFilterLogged) return;
	      if (!this.allowedCariReady) return;
	      if (!Array.isArray(this.rows) || !this.rows.length) return;

	      this._cariFilterLogged = true;
	      const set = this.allowedCariGuidSet;
	      const total = this.rows.length;
	      let matched = 0;
	      const unmatched = [];
	      const allowedList = [];
	      const debugRows = [];
	      const m = this.allowedCariMatchers;
	      if (set) {
	        for (const v of set) {
	          allowedList.push(v);
	          if (allowedList.length >= 5) break;
	        }
	      }
	      for (let i = 0; i < this.rows.length; i++) {
	        const r = this.rows[i];
	        const rawCarid =
	          r && (typeof r.carid !== "undefined" || typeof r.customer_carid !== "undefined" || typeof r.currentAccountId !== "undefined" || typeof r.current_account_id !== "undefined")
	            ? (r.carid || r.customer_carid || r.currentAccountId || r.current_account_id || "")
	            : "";
	        const carid = this.normalizeGuid(rawCarid);
	        let ok = false;
	        if (carid && set && set.has(carid)) ok = true;
	        else if (!carid && m) {
	          const email = String((r && r.customer_email) || "").trim().toLowerCase();
	          const phone = String((r && r.customer_phone) || "").replace(/\D/g, "");
	          const name = String((r && r.customer_name) || "").trim().toLowerCase();
	          ok = !!(
	            (email && m.emails && m.emails.has(email)) ||
	            (phone && m.phones && m.phones.has(phone)) ||
	            (name && m.names && m.names.has(name))
	          );
	        }
	        if (ok) matched++;
	        else if (unmatched.length < 5) unmatched.push(rawCarid);

	        if (debugRows.length < 5) {
	          debugRows.push({
	            order_no: r && r.order_no,
	            rawCarid: rawCarid,
	            normCarid: carid,
	            allowedHit: ok
	          });
	        }
	      }
	      console.log("[tahsilat/list] cari filter stats =", { allowed: set ? set.size : 0, allowedSample: allowedList, total, matched, sampleUnmatchedCarid: unmatched, debugRows });
	    },

	    async fetchMikroMeta() {
	      // try {
	      //   const [smlerRes, bankalarRes] = await Promise.all([
	      //     this.$request.post("mikro/smler", {}),
	      //     this.$request.post("mikro/bankalar", {})
	      //   ]);

	      //   const smlerBody = smlerRes && smlerRes.data ? smlerRes.data : smlerRes;
	      //   const bankalarBody = bankalarRes && bankalarRes.data ? bankalarRes.data : bankalarRes;

	      //   // console.log("[tahsilat/list] mikro/smler =", smlerBody);
	      //   // console.log("[tahsilat/list] mikro/bankalar =", bankalarBody);

	      //   const smlerData = (smlerBody && (smlerBody.response || smlerBody.data)) || smlerBody;
	      //   const bankalarData = (bankalarBody && (bankalarBody.response || bankalarBody.data)) || bankalarBody;

	      //   this.mikroSmler = Array.isArray(smlerData) ? smlerData : [];
	      //   this.mikroBankalar = Array.isArray(bankalarData) ? bankalarData : [];
	      // } catch (e) {
	      //   console.log("[tahsilat/list] mikro meta fetch error =", e);
	      //   this.mikroSmler = [];
	      //   this.mikroBankalar = [];
	      // }
	    },

	    closeIntegrate() {
	      this.integrateOpen = false;
	      this.integrateLoading = false;
	      this.integrateError = "";
	      this.integrateRows = [];
	      this.integrateSm = "";
	      this.integrateBanka = "";
	      this.integrateCariKod = "";
	    },

	    async openIntegrate(row) {
	      try {
	        console.log("[tahsilat/list][integrate] row =", row);
	        this.integrateOpen = true;
	        this.integrateLoading = true;
	        this.integrateError = "";
	        this.integrateRows = [];
	        this.integrateSm = "";
	        this.integrateBanka = "";
	        this.integrateCariKod = "";

	        const orderNo = row && row.order_no ? String(row.order_no).trim() : "";
	        if (!orderNo) {
	          this.integrateError = "Sipariş numarası bulunamadı";
	          return;
	        }

	        const trx = await this.fetchTransactionEnvelope(row);
	        console.log("[tahsilat/list][integrate] payment/transaction envelope =", trx);
	        const detail = trx && trx.transactionResult ? trx.transactionResult : null;

	        const carid =
	          (row && (row.carid || row.customer_carid || row.currentAccountId || row.current_account_id))
	            ? (row.carid || row.customer_carid || row.currentAccountId || row.current_account_id)
	            : (trx && trx.customer && (trx.customer.carid || trx.customer.currentAccountId))
	              ? (trx.customer.carid || trx.customer.currentAccountId)
	              : null;

	        const cariKod = await this.resolveCariKod(carid);
	        this.integrateCariKod = cariKod || "";

	        const txDate = detail && detail.raw && detail.raw.transactionDate ? String(detail.raw.transactionDate) : (row.updated_at || row.created_at || "");
	        const paymentDate = this.parseTxDate(txDate);
	        const installment = Number((detail && detail.raw && detail.raw.installment) || row.installment || 1) || 1;
	        const totalAmount = Number(row.total_amount || (detail && detail.raw && detail.raw.lastAmount) || 0) || 0;

	        this.integrateRows = this.buildChaRows({
	          cariKod: cariKod || "",
	          paymentDate,
	          installment,
	          totalAmount
	        });
	      } catch (e) {
	        this.integrateError = (e && e.message) ? e.message : "Entegrasyon satırları oluşturulamadı";
	      } finally {
	        this.integrateLoading = false;
	      }
	    },

	    async fetchTransactionEnvelope(obj) {
	      const orderNo = obj && obj.order_no ? String(obj.order_no).trim() : "";
	      if (!orderNo) return null;

	      const provider = obj && obj.provider_code ? String(obj.provider_code).trim() : "";
	      const ref = obj && obj.client_order_reference ? String(obj.client_order_reference).trim() : "";

	      const qs = [];
	      if (provider) qs.push("provider=" + encodeURIComponent(provider));
	      if (ref) qs.push("ref=" + encodeURIComponent(ref));

	      const url = "payment/transaction/" + encodeURIComponent(orderNo) + (qs.length ? ("?" + qs.join("&")) : "");
	      const res = await this.$request.get(url);
	      const body = res && res.data ? res.data : res;

	      const tx = body && body.data ? body.data : body;
	      return {
	        transactionResult: (tx && tx.transactionResult) ? tx.transactionResult : null,
	        customer: (tx && tx.customer) ? tx.customer : (body && body.customer ? body.customer : null),
	        raw: body
	      };
	    },

	    async resolveCariKod(carid) {
	      const id = carid === null || typeof carid === "undefined" ? "" : String(carid).trim();
	      if (!id) {
	        console.log("[tahsilat/list][integrate] resolveCariKod missing carid");
	        return "";
	      }

	      try {
	        console.log("[tahsilat/list][integrate] resolveCariKod carid =", id);
	        let item = await db.caris.where("guid").equals(id).first();
	        if (!item) item = await db.caris.where("guid").equals(Number(id)).first();
	        if (!item) item = await db.caris.where("kod").equals(id).first();
	        console.log("[tahsilat/list][integrate] resolveCariKod found =", item);
	        return item && item.kod ? String(item.kod) : "";
	      } catch (e) {
	        console.log("[tahsilat/list][integrate] resolveCariKod error =", e);
	        return "";
	      }
	    },

	    parseTxDate(v) {
	      const s = String(v || "").trim();
	      if (!s) return new Date();
	      const d = new Date(s);
	      if (!isNaN(d.getTime())) return d;
	      // dd.MM.yyyy
	      const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
	      if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
	      // yyyymmdd
	      const m2 = s.match(/^(\d{4})(\d{2})(\d{2})$/);
	      if (m2) return new Date(Number(m2[1]), Number(m2[2]) - 1, Number(m2[3]));
	      return new Date();
	    },

	    formatDdMmYyyy(d) {
	      const dt = d instanceof Date ? d : new Date(d);
	      const dd = String(dt.getDate()).padStart(2, "0");
	      const mm = String(dt.getMonth() + 1).padStart(2, "0");
	      const yy = String(dt.getFullYear());
	      return dd + "." + mm + "." + yy;
	    },

	    formatYyyyMmDd(d) {
	      const dt = d instanceof Date ? d : new Date(d);
	      const dd = String(dt.getDate()).padStart(2, "0");
	      const mm = String(dt.getMonth() + 1).padStart(2, "0");
	      const yy = String(dt.getFullYear());
	      return yy + mm + dd;
	    },

	    addMonths(d, n) {
	      const dt = new Date(d.getTime());
	      const targetMonth = dt.getMonth() + Number(n || 0);
	      const day = dt.getDate();
	      dt.setDate(1);
	      dt.setMonth(targetMonth);
	      const lastDay = new Date(dt.getFullYear(), dt.getMonth() + 1, 0).getDate();
	      dt.setDate(Math.min(day, lastDay));
	      return dt;
	    },

	    round2(n) {
	      const x = Number(n || 0);
	      return Math.round((x + Number.EPSILON) * 100) / 100;
	    },

	    buildChaRows({ cariKod, paymentDate, installment, totalAmount }) {
	      const count = Math.max(1, Number(installment || 1));
	      const total = this.round2(totalAmount || 0);
	      const base = this.round2(total / count);
	      let remaining = total;

	      const rows = [];
	      for (let i = 0; i < count; i++) {
	        const isLast = i === count - 1;
	        const amt = isLast ? this.round2(remaining) : base;
	        remaining = this.round2(remaining - amt);

	        const vadeDate = this.addMonths(paymentDate, i);
	        rows.push({
	          cha_tarihi: this.formatDdMmYyyy(paymentDate),
	          cha_tip: 1,
	          cha_cinsi: 19,
	          cha_normal_Iade: 0,
	          cha_evrak_tip: 1,
	          cha_evrakno_seri: "B2B",
	          cha_cari_cins: 0,
	          cha_kod: cariKod || "",
	          cha_d_kurtar: null,
	          cha_d_cins: 0,
	          cha_d_kur: 1,
	          cha_srmrkkodu: "",
	          cha_projekodu: "",
	          cha_kasa_hizmet: 2,
	          cha_kasa_hizkod: "",
	          cha_vade: this.formatYyyyMmDd(vadeDate),
	          cha_meblag: String(amt)
	        });
	      }
	      return rows;
	    },

	    onIntegrateSmChange() {
	      const code = String(this.integrateSm || "").trim();
	      this.integrateRows = (this.integrateRows || []).map((r) => ({ ...r, cha_srmrkkodu: code }));
	    },

	    onIntegrateBankaChange() {
	      const code = String(this.integrateBanka || "").trim();
	      this.integrateRows = (this.integrateRows || []).map((r) => ({ ...r, cha_kasa_hizkod: code }));
	    },

	    smValue(item) {
	      if (!item) return "";
	      return String(item.som_kod || item.sm_kod || item.kod || item.code || item.SmKod || item.srmrkkodu || item.value || "").trim();
	    },
	    smLabel(item) {
	      if (!item) return "-";
	      const v = this.smValue(item);
	      const t = String(item.som_isim || item.ad || item.adi || item.unvan || item.name || item.aciklama || item.text || "").trim();
	      return (v ? (v + (t ? " - " + t : "")) : (t || "-"));
	    },
	    bankaValue(item) {
	      if (!item) return "";
	      return String(item.ban_kod || item.banka_kod || item.kod || item.code || item.value || "").trim();
	    },
	    bankaLabel(item) {
	      if (!item) return "-";
	      const t = String(item.ban_ismi || item.ban_isim || "").trim();
	      return t || "-";
	    },

	    openDetail(row) {
	      this.selectedRow = row || null;
	      this.sidebarOpen = true;
	      this.fetchOrderDetail(row);
	      this.fetchProviderDetail(row);
	    },

		    closeSidebar() {
		      this.sidebarOpen = false;
		      this.detailLoading = false;
		      this.providerDetail = null;
		      this.orderDetail = null;
		      this.detailError = "";
		    },

	    async fetchOrderDetail(obj) {
	      try {
	        const orderNo = obj && obj.order_no ? String(obj.order_no).trim() : "";
	        if (!orderNo) return;
	        const res = await this.$request.get("payment/result/" + encodeURIComponent(orderNo));
	        const body = res && res.data ? res.data : res;
	        this.orderDetail = body && body.data ? body.data : body;
	      } catch (e) {
	        this.orderDetail = null;
	      }
	    },

	    async fetchProviderDetail(obj) {
	      try {
	        const orderNo = obj && obj.order_no ? String(obj.order_no).trim() : "";
	        if (!orderNo) return;

	        this.detailLoading = true;
	        this.detailError = "";
	        this.providerDetail = null;

	        const provider = obj && obj.provider_code ? String(obj.provider_code).trim() : "";
	        const ref = obj && obj.client_order_reference ? String(obj.client_order_reference).trim() : "";

	        const qs = [];
	        if (provider) qs.push("provider=" + encodeURIComponent(provider));
	        if (ref) qs.push("ref=" + encodeURIComponent(ref));

	        // DÃ¶küman 3.4: Ã–deme Detayı (provider'dan)
	        const url = "payment/transaction/" + encodeURIComponent(orderNo) + (qs.length ? ("?" + qs.join("&")) : "");
	        const res = await this.$request.get(url);
	        //console.log("[tahsilat/list] payment/transaction raw =", res);
	        const body = res && res.data ? res.data : res;
	        //console.log("[tahsilat/list] payment/transaction body =", body);

	        let detail = body;
	        if (detail && detail.data) detail = detail.data;
	        if (detail && detail.transactionResult) detail = detail.transactionResult;

	        this.providerDetail = detail || null;
	        // Not: Başarısız (success=false) işlemler de detaydır; UI'da yine de gÃ¶ster.
	      } catch (e) {
	        this.detailError = (e && e.message) ? e.message : "Detay alınamadı";
	      } finally {
	        this.detailLoading = false;
	      }
	    },

    async fetchAll() {
      this.loading = true;
      try {
        await this.fetchList();
      } catch (err) {
        console.error("TAHSILAT_LIST_ERROR", err);
      } finally {
        this.loading = false;
      }
    },

    async fetchList() {
      try {
        const res = await this.$request.post("payment/list", {});
        const body = res && res.data ? res.data : res;

        if (Array.isArray(body)) {
          this._cariFilterLogged = false;
          this.rows = body;
          if (this.rows && this.rows.length) {
            console.log("[tahsilat/list] payment/list (array) first row keys =", Object.keys(this.rows[0] || {}));
            console.log("[tahsilat/list] payment/list (array) first row =", this.rows[0]);
          }
          this.logCariFilterStats();
          return;
        }

        if (body && body.success !== false) {
          this._cariFilterLogged = false;
          this.rows = Array.isArray(body.data) ? body.data : [];
          if (this.rows && this.rows.length) {
            console.log("[tahsilat/list] payment/list first row keys =", Object.keys(this.rows[0] || {}));
            console.log("[tahsilat/list] payment/list first row =", this.rows[0]);
          }
          this.logCariFilterStats();
          return;
        }

        this.rows = [];
      } catch (err) {
        console.error("PAYMENT_LIST_ERROR", err);
        this.rows = [];
      }
    },

    clearFilters() {
      this.keyword = "";
      this.statusFilter = "";
      this.providerFilter = "";
      this.sourceFilter = "";
      this.startDate = "";
      this.endDate = "";
    },

    providerName(code) {
      const item = (this.providerOptions || []).find((x) => x.provider_code === code);
      return item ? item.provider_name : code;
    },

    sourceText(source) {
      const map = {
        manuel: "Manuel",
        odeme_linki: "Ã–deme Linki",
        siparis: "Sipariş"
      };
      return map[source] || source || "-";
    },

    safeStatus(status) {
      return status || "unknown";
    },

    statusText(status) {
      const map = {
        paid: "Başarılı",
        failed: "Başarısız",
        "3d_pending": "Bekliyor",
        cancelled: "İptal",
        refunded: "İade"
      };
      return map[status] || status || "-";
    },

    fmtMoney(n) {
      const x = Number(n || 0);
      return "₺ " + x.toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    formatDate(val) {
      if (!val) return "-";
      const d = new Date(val);
      return Number.isNaN(d.getTime()) ? String(val) : d.toLocaleString("tr-TR");
    },

    normalizeDateOnly(val) {
      if (!val) return "";
      const d = new Date(val);
      if (Number.isNaN(d.getTime())) return "";
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return y + "-" + m + "-" + day;
    }
  }
};
</script>

<style scoped>
.pd-page {
  padding: 18px;
  display: grid;
  gap: 18px;
  background: #f8fafc;
  min-height: 100vh;
}

.table-wrap {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e8ecf5;
  overflow: hidden;
}

.table-head {
  padding: 14px 14px 10px;
  display: grid;
  gap: 12px;
  border-bottom: 1px solid #eef2f7;
}

.table-head h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 900;
  color: #0f172a;
}

.table-filters {
  display: grid;
  grid-template-columns: 1.2fr 170px 170px 170px 170px 200px;
  gap: 10px;
}

.pd-input {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #dbe2ea;
  padding: 0 10px;
  outline: none;
  font-weight: 600;
  color: #0f172a;
  background: #fff;
}

.pd-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.pd-btn {
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #0f172a;
  border-radius: 10px;
  padding: 10px 12px;
  font-weight: 800;
  cursor: pointer;
}

.pd-btn.xs{
  padding: 7px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 900;
}
.pd-btn.purple{
  background: #a855f7;
  border-color: #a855f7;
  color: #fff;
}
.pd-btn.purple:hover{
  filter: brightness(.96);
}

.th-center, .td-center{
  display:flex;
  justify-content:center;
}

.pd-btn.primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.active-filters {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-pill {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
}

.empty-box {
  padding: 18px;
  color: #64748b;
  font-weight: 700;
}

.pd-table {
  display: grid;
}

.pd-tr {
  display: grid;
  grid-template-columns: 140px 1.5fr 160px 120px 130px 110px 130px 80px 120px 170px 120px;
  gap: 10px;
  padding: 12px 14px;
  align-items: center;
  border-bottom: 1px solid #eef2f7;
  font-size: 13px;
}

.pd-th {
  font-weight: 900;
  color: #334155;
  background: #f8fafc;
}

.pd-tr-click {
  cursor: pointer;
}

.pd-tr-click:hover {
  background: #f8fafc;
}

.pd-overlay{
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, .45);
  z-index: 2147482000;
}
.im-overlay{ z-index: 2147484000; }
.imodal{
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: min(980px, calc(100vw - 24px));
  max-height: calc(100vh - 24px);
  overflow: hidden;
  background: #fff;
  border: 1px solid #e8ecf5;
  border-radius: 16px;
  z-index: 2147485000;
  display: grid;
  grid-template-rows: auto 1fr;
  box-shadow: 0 24px 70px rgba(15, 23, 42, .22);
}
.im-head{
  padding: 14px 14px;
  border-bottom: 1px solid #eef2f7;
  display:flex;
  align-items:flex-start;
  justify-content: space-between;
  gap: 12px;
}
.im-title{ font-weight: 1000; font-size: 14px; color:#0f172a; }
.im-sub{ margin-top: 4px; color:#64748b; font-weight: 900; font-size: 12px; }
.im-body{
  padding: 14px;
  overflow: auto;
  display:grid;
  gap: 12px;
}
.im-controls{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.im-label{ font-size: 12px; font-weight: 900; color:#334155; margin-bottom: 6px; }
.im-table{
  border: 1px solid #e8ecf5;
  border-radius: 14px;
  overflow:hidden;
}
.im-tr{
  display:grid;
  grid-template-columns: 80px 140px 120px 140px 120px 1fr;
  gap: 10px;
  padding: 10px 12px;
  align-items:center;
  border-bottom: 1px solid #eef2f7;
  font-size: 12px;
}
.im-th{
  background:#f8fafc;
  font-weight: 1000;
  color:#334155;
}
.im-tr:last-child{ border-bottom: 0; }
.im-right{ text-align: right; }
.pd-sidebar{
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 420px;
  max-width: calc(100vw - 32px);
  background: #fff;
  border-left: 1px solid #e8ecf5;
  z-index: 2147483000;
  display: grid;
  grid-template-rows: auto 1fr;
  box-shadow: -20px 0 45px rgba(15, 23, 42, .12);
}
.sb-head{
  padding: 14px 14px;
  border-bottom: 1px solid #eef2f7;
  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 12px;
}
.sb-title{
  font-weight: 1000;
  font-size: 14px;
  color:#0f172a;
}
.sb-close{
  border: 1px solid #dbe2ea;
  background:#fff;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 900;
  cursor:pointer;
}
.sb-loading, .sb-error{
  padding: 14px;
  font-weight: 800;
  color:#64748b;
}
.sb-error{ color:#b91c1c; }
.sb-body{
  padding: 14px;
  overflow:auto;
  display:grid;
  gap: 10px;
}
.sb-summary{
  border: 1px solid #e8ecf5;
  border-radius: 14px;
  padding: 12px;
  background: #fff;
  display:flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.sum-left{ min-width: 0; }
.sum-order{
  font-weight: 1000;
  font-size: 13px;
  color:#0f172a;
}
.sum-sub{
  margin-top: 6px;
  color:#64748b;
  font-weight: 800;
  font-size: 12px;
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 280px;
}
.status-pill.big{ padding: 7px 12px; font-size: 12px; }
.sb-kv{
  display:grid;
  grid-template-columns: 130px 1fr;
  gap: 10px;
  align-items: start;
  padding: 10px 10px;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  background:#f8fafc;
}
.sb-kv .k{ font-weight: 900; color:#334155; }
.sb-kv .v{ font-weight: 800; color:#0f172a; }
.sb-grid{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.sb-sec{ display:grid; gap: 8px; }
.sb-sec-title{
  font-weight: 1000;
  font-size: 13px;
  color:#0f172a;
  display:flex;
  align-items:center;
  gap: 10px;
}
.sb-sec-title::before{
  content: "";
  width: 28px;
  height: 28px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  flex: 0 0 28px;
}
.acc-box{
  border: 1px solid #e8ecf5;
  background: #f8fafc;
  border-radius: 12px;
  overflow:hidden;
}
.acc-box .row{
  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid #e8ecf5;
}
.acc-box .row:last-child{ border-bottom: 0; }
.acc-box .row span{
  color:#334155;
  font-weight: 900;
  font-size: 12px;
}
.acc-box .row b{
  color:#0f172a;
  font-weight: 900;
  font-size: 12px;
  text-align: right;
  max-width: 58%;
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.title-cell .title-main {
  font-weight: 900;
  color: #0f172a;
}
.title-cell .title-sub {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
}
.sep { margin: 0 6px; }

.provider-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid #e5eaf1;
  background: #fff;
  font-weight: 800;
  color: #0f172a;
}
.provider-badge.small { padding: 4px 8px; font-size: 12px; }

.source-pill {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid #e5eaf1;
  background: #f8fafc;
  font-weight: 800;
  color: #334155;
}

.status-pill {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 900;
  border: 1px solid transparent;
}
.status-pill.small { padding: 4px 8px; font-size: 12px; }
.st-paid { background: #f0fdf4; color: #15803d; border-color: #bbf7d0; }
.st-failed { background: #fef2f2; color: #b91c1c; border-color: #fecaca; }
.st-3d_pending { background: #fff7ed; color: #c2410c; border-color: #fed7aa; }
.st-unknown { background: #f1f5f9; color: #475569; border-color: #e2e8f0; }

.desktop-only { display: block !important; }
.mobile-only { display: none !important; }

.mobile-list { padding: 10px 12px 14px; display: grid; gap: 10px; }
.mobile-row { border: 1px solid #e8ecf5; border-radius: 14px; padding: 12px; background: #fff; cursor: pointer; }
.mobile-top { display:flex; align-items:flex-start; justify-content:space-between; gap: 10px; }
.mobile-title { font-weight: 900; color: #0f172a; }
.mobile-contact { margin-top: 6px; color:#64748b; font-weight: 700; font-size: 12px; }
.mobile-amount { font-weight: 900; color:#0f172a; white-space: nowrap; }
.mobile-bot { margin-top: 10px; display:flex; flex-wrap: wrap; gap: 8px; align-items:center; color:#334155; }

@media (max-width: 1100px) {
  .table-filters {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 820px) {
  .desktop-only { display: none !important; }
  .mobile-only { display: block !important; }
  .pd-tr { grid-template-columns: 1fr; }
}
</style>



// WEBPACK FOOTER //
// src/views/tahsilat/list.vue